import { Sparkles } from "lucide-react";

const PHRASES = {
  felice: "Che bello vederti così. Goditi questa leggerezza: te la sei meritata. 💗",
  serena: "La tua calma è una conquista. Continua a proteggere i tuoi spazi.",
  grata: "La gratitudine ti sta trasformando. Nota tutto ciò che di buono ti circonda.",
  determinata: "Questa energia è tua. Un passo alla volta, stai andando lontano.",
  stanca: "Sei stanca perché dai tanto. Oggi concediti riposo, senza sensi di colpa.",
  ansiosa: "Respira. Non devi avere tutto sotto controllo: una cosa alla volta basta.",
  triste: "Va bene non stare bene. Sii dolce con te come lo saresti con un'amica.",
  fragile: "La fragilità non è debolezza: è il coraggio di sentirti. Sei al sicuro qui.",
};

const DEFAULT_PHRASE = "Questa settimana scrivi per te. Ogni parola è un piccolo gesto d'amore. 💗";

export function WeeklyEncouragement({ entries, moods }) {
  const moodById = Object.fromEntries(moods.map((m) => [m.id, m]));
  // entries are sorted newest-first; find the most recent one with a known mood
  const recent = entries.find((e) => e.mood && moodById[e.mood]);
  const mood = recent ? moodById[recent.mood] : null;
  const phrase = mood ? PHRASES[mood.id] || DEFAULT_PHRASE : DEFAULT_PHRASE;

  return (
    <div
      data-testid="weekly-encouragement"
      className="rounded-2xl p-5 mb-6 text-white shadow-lg relative overflow-hidden"
      style={{ background: "linear-gradient(135deg,#E32C8C 0%,#8E1A52 55%,#3A0C21 100%)" }}
    >
      <div className="flex items-center gap-2 mb-2 opacity-90">
        <Sparkles className="w-4 h-4" />
        <span className="text-xs uppercase tracking-widest font-semibold">La tua frase della settimana</span>
      </div>
      <p className="font-serif text-2xl leading-snug">{phrase}</p>
      {mood && (
        <p className="text-xs text-white/85 mt-3">
          Ispirata dal tuo umore recente: <span className="font-semibold text-white">{mood.label}</span>
        </p>
      )}
    </div>
  );
}
